export default __webpack_public_path__ + "static/media/profile1.f98c5815.jpeg";